import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useProgress } from '../context/ProgressContext';
import { getTrophyById } from '../data/trophies';
import { lessons } from '../data/lessons';
import './TrophyDetailPage.css';

export const TrophyDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { progress } = useProgress();

  const trophy = id ? getTrophyById(id) : null;
  const unlockData = id ? progress.trophiesUnlocked[id] : null;

  if (!trophy) {
    return (
      <div className="trophy-detail-page">
        <div className="trophy-not-found">
          <h1>Trofeul nu a fost găsit</h1>
          <Link to="/trofee" className="btn btn-primary">
            Înapoi la Trofee
          </Link>
        </div>
      </div>
    );
  }

  const relatedLesson = lessons.find((l) => l.trofeulId === trophy.id);

  const getCategoryInfo = (category: typeof trophy.categorie) => {
    const info = {
      web: { label: 'Dezvoltare Web', emoji: '🌐' },
      game: { label: 'Mini-Joc', emoji: '🎮' },
      ai: { label: 'Inteligență Artificială', emoji: '🤖' },
      bonus: { label: 'Bonus', emoji: '⭐' },
    };
    return info[category];
  };

  const categoryInfo = getCategoryInfo(trophy.categorie);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('ro-RO', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="trophy-detail-page">
      <button className="back-btn" onClick={() => navigate(-1)} type="button">
        ← Înapoi
      </button>

      <div className="trophy-detail-card">
        <div className="trophy-detail-header">
          <div
            className="trophy-detail-icon"
            dangerouslySetInnerHTML={{ __html: trophy.icon }}
          />
          <div className="trophy-detail-info">
            <span className={`trophy-detail-category trophy-category-${trophy.categorie}`}>
              {categoryInfo.emoji} {categoryInfo.label}
            </span>
            <h1 className="trophy-detail-name">{trophy.nume}</h1>
          </div>
        </div>

        <p className="trophy-detail-description">{trophy.descriere}</p>

        {unlockData ? (
          <div className="trophy-unlock-info">
            <span className="unlock-badge">✓ Deblocat</span>
            <span className="unlock-date">
              {formatDate(unlockData.unlockedAt)}
            </span>
          </div>
        ) : (
          <div className="trophy-locked-info">
            <span className="locked-badge">🔒 Blocat</span>
            <p>Completează lecția asociată pentru a debloca acest trofeu.</p>
          </div>
        )}

        {relatedLesson && (
          <div className="related-lesson">
            <h3>Lecție Asociată</h3>
            <Link to={`/lectie/${relatedLesson.id}`} className="related-lesson-card">
              <span className="related-lesson-day">Ziua {relatedLesson.id}</span>
              <span className="related-lesson-title">{relatedLesson.titlu}</span>
              <span className="related-lesson-week">
                Săptămâna {relatedLesson.saptamana}
              </span>
            </Link>
          </div>
        )}

        <div className="trophy-actions">
          <Link to="/trofee" className="btn btn-secondary">
            Vezi Toate Trofeele
          </Link>
          {relatedLesson && !unlockData && (
            <Link to={`/lectie/${relatedLesson.id}`} className="btn btn-primary">
              Începe Lecția
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
